import Api from "./api.service";

const platform = "admin";

export default {
    login: (data) => Api.post("auth/login", { ...data, platform }),
    logout: () => Api.get(`auth/logout?platform=${platform}`),
    refresh: () => Api.post(`auth/refresh?platform=${platform}`, null),
};
